"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerPublicMetaContextProvider = exports.ServerPublicMetaContext = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const client_2 = require("@apollo/client");
const AuthConnector_1 = require("../hooks/AuthConnector");
const GET_CONFIG = (0, client_2.gql) `
  query {
    webUIConfig {
      theme {
        primary
        secondary
        logoUrl
      }
    }
    legalDisclaimer
    serverInfo {
      authConfiguration {
        region
        userPoolId
        clients {
          key
          value
        }
        samlProviders {
          label
          providerName
        }
        passwordRules {
          validRegexPatterns
          validText
        }
        samlConfig {
          domain
          redirectSignIn
          redirectSignOut
          redirectConfigEditorSignIn
          redirectConfigEditorSignOut
          responseType
          scope
        }
      }
    }
  }
`;
const defaultConfig = {
    theme: {
        primary: '#56CCF2',
        secondary: '#455157',
        logoUrl: '/static/media/terrago-streetlights-logo-512.6fc4397f.png',
    },
    legalDisclaimer: null,
    samlProviders: null,
    passwordRules: null,
    redirectUrl: null,
    clientId: null,
    authServerDomain: null,
};
exports.ServerPublicMetaContext = (0, react_1.createContext)(defaultConfig);
const ServerPublicMetaContextProvider = props => {
    const { data, loading, error } = (0, client_1.useQuery)(GET_CONFIG);
    const [configuration, setConfiguration] = (0, react_1.useState)(null);
    // use memo since I create a new object for now to avoid rerendering
    (0, react_1.useEffect)(() => {
        var _a;
        if (data) {
            const { region, userPoolId, clients, samlConfig, samlProviders, passwordRules, } = data.serverInfo.authConfiguration;
            try {
                localStorage.setItem('passwordRules', JSON.stringify(passwordRules));
            }
            catch (e) { }
            const client = clients.find((client) => client.key === 'webClient');
            const clientId = client ? client.value : '';
            setConfiguration(data
                ? Object.assign(Object.assign({}, data.webUIConfig), { legalDisclaimer: data.legalDisclaimer, samlProviders: samlProviders, redirectUrl: samlConfig[props.redirectSignInField || 'redirectSignIn'], clientId: clientId, authServerDomain: samlConfig.domain }) : null);
            const authConfig = {
                region,
                userPoolId: userPoolId,
                userPoolWebClientId: clientId,
                oauth: Object.assign(Object.assign({}, samlConfig), { redirectSignIn: samlConfig[props.redirectSignInField || 'redirectSignIn'], redirectSignOut: samlConfig[props.redirectSignOutField || 'redirectSignOut'] }),
            };
            AuthConnector_1.AuthConnector.configureAuth(authConfig);
            (_a = props.onLoadAuthConfig) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    }, [data]);
    if (error) {
        throw new Error(error.message);
    }
    if (loading) {
        return props.renderLoading ? props.renderLoading() : null;
    }
    return configuration ? (react_1.default.createElement(exports.ServerPublicMetaContext.Provider, { value: configuration }, props.children)) : null;
};
exports.ServerPublicMetaContextProvider = ServerPublicMetaContextProvider;
//# sourceMappingURL=serverPublicMetaContext.js.map